<div class="content">
    <h1 class="page-title">
        Programa de Capacitação da CBT recebe Certificação OURO da ITF
    </h1>
    <p>
        A Federação Internacional de Tênis (ITF) anunciou em 2013 a criação das
        certificações Ouro, Prata e Bronze para os programas de capacitação de
        suas nações filiadas e o Brasil foi um dos países contemplados e
        reconhecidos com a Certificação Ouro pelo trabalho que é desenvolvido
        para capacitar professores e treinadores de tênis em todo o país.
    </p>

    <p>
        A Certificação Ouro do Programa de Capacitação da CBT é válida a partir
        de janeiro de 2014.
    </p>

    <p>
        <strong
            >O que é a Certificação dos Programas de Formação de
            Treinadores?</strong
        >
    </p>

    <p>
        O objetivo geral deste programa é assegurar que a formação dos
        treinadores que se realiza nos países membros da ITF esteja cumprindo os
        requisitos mínimos estabelecidos pela ITF nos diferentes níveis.
    </p>

    <p>
        O reconhecimento da ITF se baseia em critérios e normas para a formação
        de treinadores que foram acordados pelos diretores de capacitação das
        principais nações do tênis e aprovado posteriormente pela Comissão de
        Treinadores da ITF e pela diretoria da ITF.
    </p>

    <p>
        Com isso a ITF espera ajudar as confederações nacionais a criar seu
        próprio programa de formação de treinadores e melhorar o nível de ensino
        do tênis em todo o mundo.
    </p>

    <p><strong>Níveis de Certificação</strong></p>

    <p>
        A ITF reconhece os programas de capacitação de treinadores das
        confederações nacionais em três níveis: Ouro, Prata e Bronze.
    </p>

    <p><strong>Critérios para a Certificação</strong></p>

    <p>
        Para cada Nível de Certificação são analisados diferentes requisitos,
        entre os quais destacamos: carga horária de 300 horas, capacidade para
        ministrar os cursos equivalentes aos Níveis 1,2 e 3 da ITF, sistema de
        competências e avaliações, calendário de cursos, equipe de tutores,
        treinamento da equipe, produção de materiais, site oficial, sistema de
        graduação de treinadores, realização de um Workshop Nacional, estrutura
        do departamento, entre outros.
    </p>

    <p>&nbsp;Atualmente há 16 países com Certificação Nível Ouro:</p>

    <table
        border="0"
        cellpadding="0"
        cellspacing="0"
        style="width: 187px;"
        width="187"
    >
        <tbody>
            <tr>
                <td nowrap="nowrap" style="width: 72px; height: 20px;">
                    <p>·&nbsp;Austrália&nbsp;</p>
                </td>
                <td nowrap="nowrap" style="width: 116px; height: 20px;">
                    <p>&nbsp;·&nbsp;Alemanha</p>
                </td>
            </tr>
            <tr>
                <td nowrap="nowrap" style="width: 72px; height: 20px;">
                    <p>·&nbsp;Áustria&nbsp;</p>
                </td>
                <td nowrap="nowrap" style="width: 116px; height: 20px;">
                    <p>&nbsp;·&nbsp;Grã-Bretanha</p>
                </td>
            </tr>
            <tr>
                <td nowrap="nowrap" style="width: 72px; height: 20px;">
                    <p>·&nbsp;Bélgica&nbsp;</p>
                </td>
                <td nowrap="nowrap" style="width: 116px; height: 20px;">
                    <p>&nbsp;·&nbsp;Itália</p>
                </td>
            </tr>
            <tr>
                <td nowrap="nowrap" style="width: 72px; height: 20px;">
                    <p>·&nbsp;Brasil&nbsp;</p>
                </td>
                <td nowrap="nowrap" style="width: 116px; height: 20px;">
                    <p>&nbsp;·&nbsp;Irlanda</p>
                </td>
            </tr>
            <tr>
                <td nowrap="nowrap" style="width: 72px; height: 20px;">
                    <p>· Canadá&nbsp;</p>
                </td>
                <td nowrap="nowrap" style="width: 116px; height: 20px;">
                    <p>&nbsp;·&nbsp;Portugal</p>
                </td>
            </tr>
            <tr>
                <td nowrap="nowrap" style="width: 72px; height: 20px;">
                    <p>·&nbsp;Colômbia&nbsp;</p>
                </td>
                <td nowrap="nowrap" style="width: 116px; height: 20px;">
                    <p>&nbsp;·&nbsp;Espanha</p>
                </td>
            </tr>
            <tr>
                <td nowrap="nowrap" style="width: 72px; height: 20px;">
                    <p>· Finlândia&nbsp;</p>
                </td>
                <td nowrap="nowrap" style="width: 116px; height: 20px;">
                    <p>&nbsp;·&nbsp;Suíça</p>
                </td>
            </tr>
            <tr>
                <td nowrap="nowrap" style="width: 72px; height: 20px;">
                    <p>· França&nbsp;</p>
                </td>
                <td nowrap="nowrap" style="width: 116px; height: 20px;">
                    <p>&nbsp;·&nbsp;Holanda</p>
                </td>
            </tr>
        </tbody>
    </table>
</div>
